import { z } from 'zod';

export const TradeStudyProcessPoint = z.object({
  process_name: z.string(),
  total_time: z.coerce.number(),
  total_cost: z.coerce.number(),
  total_material_cost: z.coerce.number(),
  total_labour_cost: z.coerce.number(),
  total_capex_cost: z.coerce.number(),
});

export const TradeStudyPartOption = z.object({
  persistent_id: z.string(),
  name: z.string(),
});

export const TradeStudyTimeDistributionPoint = z.object({
  process_name: z.string(),
  total_time: z.coerce.number(),
});

export const TradeStudyChartsSummary = z.object({
  total_time_required_hours: z.coerce.number(),
  total_cost_required: z.coerce.number(),
  total_material_cost: z.coerce.number(),
  total_labour_cost: z.coerce.number(),
  total_capex_cost: z.coerce.number(),
  time_per_assembly: z.coerce.number(),
  monthly_required_hours: z.coerce.number(),
  m_days_per_month: z.coerce.number().int(),
});

export const TradeStudyCapacityVsRequiredRow = z.object({
  shift_label: z.string(),
  required_hours_per_month: z.coerce.number(),
  capacity_hours_per_month: z.coerce.number(),
});

export const TradeStudyCompletionByShiftRow = z.object({
  shift_label: z.string(),
  months: z.coerce.number(),
  days: z.coerce.number(),
});

export const TradeStudyCostCompositionRow = z.object({
  process_name: z.string(),
  subtotal_cost: z.coerce.number(),
  subtotal_material_cost: z.coerce.number(),
  subtotal_labour_cost: z.coerce.number(),
  subtotal_markup: z.coerce.number(),
  subtotal_tax: z.coerce.number(),
  subtotal_capex: z.coerce.number(),
});

export const TradeStudyCharts = z.object({
  summary: TradeStudyChartsSummary,
  time_per_part: z.array(TradeStudyProcessPoint),
  cost_per_part: z.array(TradeStudyProcessPoint),
  parts: z.array(TradeStudyPartOption),
  processes_by_part: z.record(z.string(), z.array(TradeStudyProcessPoint)),
  cost_composition_by_part: z.record(
    z.string(),
    z.array(TradeStudyCostCompositionRow),
  ),
  time_distribution: z.array(TradeStudyTimeDistributionPoint),
  capacity_vs_required_hours: z.array(TradeStudyCapacityVsRequiredRow),
  completion_time_by_shift: z.array(TradeStudyCompletionByShiftRow),
  cost_composition_by_process: z.array(TradeStudyCostCompositionRow),
});

export type TradeStudyCharts = z.infer<typeof TradeStudyCharts>;
